<template>
  <div class="loginpage">
    <div class="loginbox" :style="{width:clientHeight*1.77+'px'}">
      <div class="imgbox">
        <img src="../assets/loginimg.png" alt="" />
        <div class="title">
          <img src="../assets/logo2.png" alt="">
        </div>
      </div>
      <div class="loginright">
        <div class="login">
          <Form v-if="resetPassword" label-position="left" :label-width="100">
            <FormItem label="手机号">
              <Input v-model="username3"></Input>
            </FormItem>
            <FormItem label="验证码">
              <Input v-model="yzm"></Input>
              <Button
                type="primary"
                class="getyzm2"
                :disabled="isdisabled2"
                @click="postyzm2"
                >获取验证码</Button
              >
            </FormItem>
            <FormItem label="新密码">
              <Input v-model="password3" type="password"></Input>
            </FormItem>
            <FormItem label="确认新密码">
              <Input v-model="password4" type="password"></Input>
            </FormItem>
            <FormItem class="forgetPswFooter">
              <Button type="primary" @click="resetPsMethod" style="float: left"
                >提交</Button
              >
              <Button
                type="primary"
                @click="resetPassword = false"
                style="float: right"
                >返回</Button
              >
            </FormItem>
          </Form>
          <Tabs v-else value="name1" :animated="false">
            <TabPane label="账号登录" name="name1">
              <div class="content1">
                <Input
                  placeholder="请输入账号"
                  class="username"
                  v-model="username1"
                >
                  <Icon type="md-person" slot="prefix" />
                </Input>
                <Input
                  placeholder="请输入密码"
                  class="password"
                  v-model="password1"
                  type="password"
                  @keyup.enter.native="zhLogin"
                >
                  <Icon type="ios-key" slot="prefix" />
                </Input>
                <!-- <p @click="resetPassword = !resetPassword">忘记密码</p> -->
                <Button type="primary" @click="zhLogin" :loading="loading">登录</Button>
              </div>
            </TabPane>
            <TabPane label="验证码登录" name="name2">
              <div class="content2">
                <Input
                  placeholder="请输入手机号"
                  class="username"
                  v-model="username2"
                >
                  <Icon type="md-person" slot="prefix" />
                </Input>
                <div class="yanzhengma">
                  <Input
                    placeholder="请输入验证码"
                    class="password"
                    v-model="password2"
                    @keyup.enter.native="yzmLogin"
                  >
                    <Icon type="ios-key" slot="prefix" />
                  </Input>
                  <Button
                    type="primary"
                    class="getyzm"
                    :disabled="isdisabled"
                    @click="postyzm"
                    >获取验证码</Button
                  >
                </div>
                <Button type="primary" class="login2" @click="yzmLogin" :loading="loading">登录</Button
                >
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Tabs,
  TabPane,
  Input,
  Icon,
  Button,
  Form,
  FormItem,
  Alert,
  Message,
} from "view-design";
import Request from "../utils/request";
import config from "../config";

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Tabs,
    TabPane,
    Input,
    Icon,
    Button,
    Form,
    FormItem,
    Alert,
    Message,
  },
  data() {
    // 这里存放数据
    return {
      username1: "",
      password1: "",
      username2: "",
      password2: "",
      username3: "",
      password3: "",
      password4: "",
      yzm: "",
      time: 60,
      time2: 60,
      isdisabled: false, //获取验证码是否可点击
      isdisabled2: false, //获取验证码是否可点击
      resetPassword: false, //是否显示修改密码页面
      t: null,
      t2: null,
      moduleJson: "",
      clientHeight:document.body.clientHeight,
      loading:false
    };
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
      let that = this;
      window.onresize =() =>{
          return (()=>{
              window.clientHeight = document.body.clientHeight;
              that.clientHeight = window.clientHeight;
          })()
      };
  },
  // 这里存放数据
  beforeCreate() {},
  // 生命周期 - 挂载之前
  beforeMount() {},
  // 生命周期 - 更新之前
  beforeUpdate() {},
  // 生命周期 - 更新之后
  updated() {},
  // 生命周期 - 销毁之前
  beforeDestroy() {
    this.time = 60;
    this.time2 = 60;
    this.isdisabled = false; //获取验证码是否可点击
    this.isdisabled2 = false; //获取验证码是否可点击
    if (this.t) {
      clearInterval(this.t);
    }
    if (this.t2) {
      clearInterval(this.t2);
    }
  },
  // 生命周期 - 销毁完成
  destroyed() {},
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
  // 方法集合
  methods: {
    //验证码登录,获取验证码
    postyzm() {
      //用于清除定时器
      if (this.t) {
        clearInterval(this.t);
      }
      if (this.username2 == "") {
        this.$Message.error("请输入手机号");
        return;
      }
      Request.postRequest(config.SXG_baseUrl + "/api/login/SMSMessage", {
        sPhoneNUM: this.username2,
      })
        .then((res) => {
          if (res.code == 200) {
            this.$Message.success("验证码发送成功");
          } else {
            this.$Message.warning(res.message);
          }
        })
        .catch((err) => {
          this.$Message.error("验证码发送失败");
        });

      this.isdisabled = true;
      document.querySelector(".getyzm").innerHTML = this.time + "秒后再次发送";
      this.t = setInterval(() => {
        if (this.time >= 1 && document.querySelector(".getyzm")) {
          console.log("time1");
          document.querySelector(".getyzm").innerHTML =
            --this.time + "秒后再次发送";
        } else if (this.time <= 0 && document.querySelector(".getyzm")) {
          clearInterval(this.t);
          document.querySelector(".getyzm").innerHTML = "获取验证码";
          this.isdisabled = false;
          this.time = 60;
        }
      }, 1000);
    },

    //更改密码中获取验证码
    postyzm2() {
      if (this.username3) {
        //用于清除定时器
        if (this.t2) {
          clearInterval(t2);
        }
        Request.postRequest(config.SXG_baseUrl + "/api/login/SMSMessage", {
          sPhoneNUM: this.username3,
        })
          .then((res) => {
            if (res.code == 200) {
              this.$Message.success("验证码发送成功");
            } else {
              this.$Message.warning(res.message);
            }
          })
          .catch((err) => {
            this.$Message.error("验证码发送失败");
          });
        this.isdisabled2 = true;
        document.querySelector(".getyzm2").innerHTML =
          this.time2 + "秒后再次发送";
        this.t2 = setInterval(() => {
          if (this.time2 >= 1 && document.querySelector(".getyzm2")) {
            console.log("time2");
            document.querySelector(".getyzm2").innerHTML =
              --this.time2 + "秒后再次发送";
          } else if (this.time2 <= 0 && document.querySelector(".getyzm2")) {
            clearInterval(this.t2);
            document.querySelector(".getyzm2").innerHTML = "获取验证码";
            this.isdisabled2 = false;
            this.time2 = 60;
          }
        }, 1000);
      } else {
        this.$Message.error("请输入手机号");
      }
    },

    //验证码登录,登录
    yzmLogin() {
      if (this.username2) {
        this.loading = true
        Request.postRequest(config.SXG_baseUrl + "/api/login/SMSMessage", {
          sPhoneNUM: this.username2,
          authCode: this.password2,
        })
          .then((res) => {
            if (res.code == 200) {
              // console.log(JSON.parse(res.data).UserJID);
              // localStorage.setItem("UserJID", JSON.parse(res.data).UserJID);
              // this.username2 = "";
              // this.password2 = "";
              Request.postRequest(
                config.SXG_baseUrl + "/api/login/getUserRole",
                {
                  Cellphone: this
                    .username2 /* localStorage.getItem("UserJID") */,
                }
              ).then((res1) => {
                if (res1.code == 200) {
                  this.loading = false
                  Message.success("登录成功");
                  this.username2 = "";
                  this.password2 = "";
                  let Module = null;
                  if (res1.data.Center.length != 0 && res1.data.Doc.length == 0) {
                    localStorage.setItem(
                      "Role",
                      JSON.stringify(res1.data.Center[0])
                    );
                    localStorage.setItem("center", "t");
                    Module = JSON.parse(res1.data.Center[0].ModuleJson);
                    if (Module[0].ModuleName == "首页") {
                      if (res1.data.Center.length != 0) {
                        this.$router.replace("/HomePage/DataTable");
                        console.log(123);
                      } else {
                        this.$router.replace("/HomePage/DoctorFirstPage");
                        console.log(123);
                      }
                    } else if (Module[0].ModuleName == "案例管理") {
                      this.$router.replace("/HomePage/CaseDiscussion");
                    } else if (Module[0].ModuleName == "管理后台") {
                      this.$router.replace("/HomePage/DoctorManagement");
                    } else if (Module[0].ModuleName == "教学管理") {
                      // this.$router.replace("/HomePage");
                    } else if (Module[0].ModuleName == "学术社区") {
                      // this.$router.replace("/HomePage");
                    }
                    Request.addLog('登录','登录系统')
                  } else if (
                    res1.data.Doc.length != 0 &&
                    res1.data.Center.length == 0
                  ) {
                    if (
                      (res1.data.Doc[0].DocType ==
                        "基层" && res1.data.Doc[0].Status != 3)
                    ) {
                      if(res1.data.Doc[0]){
                        localStorage.setItem('Role',JSON.stringify(res1.data.Doc[0]))
                        
                      }
                      this.$router.push("/Register");
                    } else {
                      localStorage.setItem(
                        "Role",
                        JSON.stringify(res1.data.Doc[0])
                      );
                      Module = JSON.parse(res1.data.Doc[0].ModuleJson);
                      if (Module[0].ModuleName == "首页") {
                        if (res1.data.Center.length != 0) {
                          localStorage.setItem("center", "2");
                          this.$router.replace("/HomePage/DataTable");
                          console.log(123);
                        } else {
                          if(res1.data.Doc[0] && res1.data.Doc[0].DocType == "基层"){
                            console.log("基层医生")
                            localStorage.setItem("center", "0");
                            this.$router.replace("/HomePage/BaseDoctorPage")
                          }else{
                            localStorage.setItem("center", "1");
                            this.$router.replace("/HomePage/DoctorFirstPage");
                            console.log(123);
                          }
                          
                        }
                      } else if (Module[0].ModuleName == "案例管理") {
                        this.$router.replace("/HomePage/CaseDiscussion");
                      } else if (Module[0].ModuleName == "管理后台") {
                        this.$router.replace("/HomePage/DoctorManagement");
                      } else if (Module[0].ModuleName == "教学管理") {
                        // this.$router.replace("/HomePage");
                      } else if (Module[0].ModuleName == "学术社区") {
                        // this.$router.replace("/HomePage");
                      }
                    }
                    Request.addLog('登录','登录系统')
                  } else {
                    localStorage.setItem("Role",'');
                    localStorage.setItem('Role1','')
                    this.$router.push("/Register");
                  }

                  // localStorage.setItem("Role", res1.data[0].Role);
                  // localStorage.setItem("ShopID", res1.data[0].ShopID);
                  // Request.postRequest(
                  //   config.SXG_baseUrl + "/api/login/getRoleModule",
                  //   {
                  //     Role: res1.data[0].Role,
                  //   }
                  // ).then((res1) => {
                  //   localStorage.setItem("ModuleJson", res1.data[0].ModuleJson);
                  //   let module = JSON.parse(res1.data[0].ModuleJson);
                  //   console.log(module);
                  //   if (module[0].ModuleName == "首页") {
                  //     this.$router.replace("/HomePage/DataTable");
                  //   } else if (module[0].ModuleName == "健康管理") {
                  //     if (module[0].SubModule[0].SubName == "档案管理") {
                  //       this.$router.replace("/HomePage/FilesManage");
                  //     } else {
                  //       this.$router.replace("/HomePage/FollowManage");
                  //     }
                  //   } else if (module[0].ModuleName == "在线咨询") {
                  //     this.$router.replace("/HomePage/OnlineConsult");
                  //   } else if (module[0].ModuleName == "自检咨询") {
                  //     this.$router.replace("/HomePage/SelfCheck");
                  //   } else if (module[0].ModuleName == "医生管理") {
                  //     if (module[0].SubModule[0].SubName == "医生管理") {
                  //       this.$router.replace("/HomePage/DoctorManagement");
                  //     } else {
                  //       this.$router.replace("/HomePage/DoctorScheduling");
                  //     }
                  //   } else if (module[0].ModuleName == "远程会诊") {
                  //     this.$router.replace("/HomePage/");
                  //   } else if (module[0].ModuleName == "教学管理") {
                  //     if (module[0].SubModule[0].SubName == "医生培训") {
                  //       this.$router.replace("/HomePage/");
                  //     } else {
                  //       this.$router.replace("/HomePage/");
                  //     }
                  //   }
                  //   connection.disconnect();
                  // });
                } else {
                  this.loading = false
                  Message.info(res1.message);
                }
              });
            } else {
              this.loading = false
              this.$Message.error("登录失败，" + res.message);
              console.log("登录失败", res.message);
            }
          })
          .catch((err) => {
            this.loading = false
            console.log("登录失败", err);
          });
      } else {
        this.$Message.warning("请输入账号");
      }
    },

    //修改密码
    resetPsMethod() {
      Request.postRequest(config.SXG_baseUrl + "/api/login/ForgetPsw", {
        sPhoneNUM: this.username3,
        authCode: this.yzm,
        UserPws: this.password3,
      }).then((res) => {
        if (this.password3 == this.password4) {
          if (res.code == 200) {
            this.resetPassword = false;
            this.$Message.success("密码更新成功");
          }
        } else {
          this.$Message.error("请确认密码输入是否一样");
        }
      });
    },

    //账号密码登录
    zhLogin() {
      if (this.username1 == "") {
        return this.$Message.warning("请输入账号");
      }
      if (this.password1 == "") {
        return this.$Message.warning("请输入密码");
      }
      this.loading = true
      Request.getRequest(config.SXG_baseUrl + "/api/login/getkey", {
        UserCount: this.username1,
      }).then((res) => {
        if (res.code != 200) {
          this.loading = false
          this.$Message.info(res.message);
          return;
        } else {
          if (res.data.desStrKey == "") {
            this.loading = false
            this.$Message.error("输入的用户名不存在");
            return;
          }
          console.log(res);
          let { data } = res;
          // localStorage.setItem("UserJID", data.jid);
          var d = data.desStrKey;
          var jidhead = data.jid;
          var keyHex = CryptoJS.enc.Utf8.parse(jidhead.split("@@")[0]);
          var encrypted = CryptoJS.DES.encrypt(this.password1, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
          });
          let NewPass = d + " " + encrypted;
          console.log(NewPass);
          var uName = data.jid;
          //链接远程服务器
          var BOSH_SERVICE = config.login_baseUrl_xmpp;
          var connection = new Strophe.Connection(BOSH_SERVICE);
          let _this = this;
          connection.connect(uName, NewPass, function(status) {
            if (status == 1) {
              // message.loading({ content: '正在登录...', key: "loging" });
              // Message.loading({ content: 'Loading...'})
              this.loading = false
            } else if (status == 5) {
              // _this.getUserInfoMethod(uName)
              //获取登录账号的userJID
              Request.postRequest(
                config.SXG_baseUrl + "/api/login/getUserRole",
                {
                  Cellphone: _this.username1,
                }
              ).then((res1) => {
                if (res1.code == 200) {
                  _this.loading = false
                  let Module = null;
                  if (res1.data.Center.length != 0) {
                    localStorage.setItem(
                      "Role",
                      JSON.stringify(res1.data.Center[0])
                    );
                    Module = JSON.parse(res1.data.Center[0].ModuleJson);
                  }else if(res1.data.Doc.length != 0){
                    localStorage.setItem(
                      "Role",
                      JSON.stringify(res1.data.Doc[0])
                    );
                    if(res1.data.Doc[0].DocType == '基层'&&res1.data.Doc[0].Status!=3){
                      _this.$router.push("/Register");
                      return ;
                    }
                    Module = JSON.parse(res1.data.Doc[0].ModuleJson);
                  } else {
                    localStorage.setItem("Role", '');
                    localStorage.setItem("Role1", '');
                    _this.$router.push("/Register");
                    return
                  }
                  Request.addLog('登录','登录系统')
                  if (Module[0].ModuleName == "首页") {
                    Message.success("登录成功",1);
                    if (res1.data.Doc.length != 0 && res1.data.Doc[0].RoleID == 3 ) {
                      _this.$router.replace("/HomePage/DataTable");
                      localStorage.setItem("center", "2");
                    }else {
                      if(res1.data.Doc.length != 0){
                        if(res1.data.Doc[0].DocType == "基层"){
                          localStorage.setItem("center", "0");
                          _this.$router.replace("/HomePage/BaseDoctorPage");
                      }else{
                          localStorage.setItem("center", "1");
                          _this.$router.replace("/HomePage/DoctorFirstPage");
                        }
                      }
                      else{
                        localStorage.setItem("center", "1");
                          _this.$router.replace("/HomePage/DoctorFirstPage");
                      }
                      
                      
                    }
                  } else if (Module[0].ModuleName == "案例管理") {
                    Message.success("登录成功",1);
                    _this.$router.replace("/HomePage/CaseDiscussion");
                  } else if (Module[0].ModuleName == "管理后台") {
                    Message.success("登录成功",1);
                    _this.$router.replace("/HomePage/DoctorManagement");
                  } else if (Module[0].ModuleName == "教学管理") {
                    // _this.$router.replace("/HomePage");
                  } else if (Module[0].ModuleName == "学术社区") {
                    // _this.$router.replace("/HomePage");
                  }
                  connection.disconnect();
                } else {
                  _this.loading = false
                  Message.info(res1.message);
                }
              });
              //进行页面跳转
              //
            } else if (status == 4) {
              // message.error({ content: '输入的密码错误', key: "loging", duration: 2 });
              _this.loading = false
              Message.error("输入的密码有误");
            } else {
              _this.loading = false
              console.log(status);
              // message.error({ content: 'Strophe is disconnecting', key: "loging", duration: 2 });
              // Message.error("登录失败12345")
            }
          });
        }
      });
    },
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    clientHeight(newVal,oldVal){
            console.log(newVal);//浏览器窗口变化时，打印宽度。
        }
  },
};
</script>

<style lang="less">
.loginpage {
  background: #2d8bea;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-size: 100% 100%;
  // min-height: 960px;
  position: relative;
  .loginbox {
    width: 90%;
    height: 80%;
    position: relative;
    border-radius: 30px;
    overflow: hidden;
    display: flex;
    .imgbox {
      width: 60%;
      height: 100%;
      position: relative;
      img {
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
      }
      .title {
        position: absolute;
        left: 10%;
        top: 8%;
        font-size: 30px;
        color: #fff;
        font-weight: bold;
        z-index: 100;
        text-shadow: 0.1em 0.1em #333;
        img{
          display: block;
          height: 63px;
          width: 295px;
        }
      }
    }
    .loginright {
      width: 40%;
      height: 100%;
      position: relative;
      background: white;
      .login {
        width: 50%;
        height: 60%;
        position: absolute;
        right: 20%;
        top: 25%;
        .ivu-tabs {
          .ivu-tabs-bar {
            border-bottom: none;
            // width: 90%;
            // .ivu-tabs-nav{
            //   width: 100%;
            //   display: flex;
            //   justify-content: space-between;
            //   .ivu-tabs-ink-bar{
            //     width: 46%!important;
            //     transform: ;
            //   }
            //   display: flex;
            //   justify-content: space-between;
            //   .ivu-tabs-tab{
            //   width: 40%;
            // }
            // }
          }
          .ivu-tabs-content {
            .content1 {
              width: 90%;
              height: 160px;
              margin-top: 10px;
              position: relative;
              .username {
                width: 100%;
              }
              .password {
                width: 100%;
                margin-top: 20px;
              }
              p {
                float: right;
                margin-top: 5px;
                color: rgb(196, 190, 190);
                cursor: pointer;
              }
              .ivu-btn {
                float: left;
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
              }
            }
            .content2 {
              width: 90%;
              height: 160px;
              margin-top: 10px;
              position: relative;
              .username {
                width: 100%;
              }
              .yanzhengma {
                margin-top: 20px;
                display: flex;
                width: 100%;
                justify-content: space-between;
                font-size: 12px;
                .password {
                  width: 53%;
                }
                .getyzm {
                  width: 44%;
                  font-size: 12px;
                  padding: 0;
                  font-size: 14px;
                }
              }
              .login2 {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
